<template>
  <a-modal
  :width="modal.width"
  :visible="visible"
  :confirmLoading="confirmLoading"
  :bodyStyle="bodyStyle"
  @ok="handleOk"
  @cancel="handleCancel"
  cancelText="Close"
  wrapClassName="ant-modal-cust-warp"
  style="top: 0; padding: 0;">
    <template slot="title">
      <div style="width: 100%;height:20px;padding-right:32px;">
        <div style="float: left;">{{ title }}</div>
        <div style="float: right;">
          <a-button
            icon="fullscreen"
            style="width:56px;height:100%;border:0"
            @click="handleClickToggleFullScreen"/>
        </div>
      </div>
    </template>
      <a-spin :spinning="confirmLoading">
        <a-card :bordered="false">
          <detail-list>
            <detail-list-item term="UID">1000001</detail-list-item>
            <detail-list-item term="Aadhaar CardName"></detail-list-item>
            <detail-list-item term="PAN CardNo.">BQUPP3026L</detail-list-item>
            <detail-list-item term="PAN Cardname">JAVAJI PARTHASARADHI</detail-list-item>
            <detail-list-item term="Phone">8158982662</detail-list-item>
          </detail-list>
          <a-card style="margin-top: 24px" title="CustomerDetail Info">
            <detail-list>
              <detail-list-item term="Monthly Income">Fu Xiaoxiao</detail-list-item>
              <detail-list-item term="Output Date">32943898021309809423</detail-list-item>
              <detail-list-item term="Number of Children">3321944288191034921</detail-list-item>
              <detail-list-item term="Education Level">18112345678</detail-list-item>
              <detail-list-item term="WorkType">Intersection of Huanggushan Rd and Gongzhuan Rd, Xihu District, Hangzhou, Zhejiang</detail-list-item>
            </detail-list>
          </a-card>
          <a-card style="margin-top: 24px"  title="Customer Contact Info">
            <detail-list>
              <detail-list-item term="Emergency Contact1Name">Fu Xiaoxiao</detail-list-item>
              <detail-list-item term="Emergency Contact1Phone">18677876567</detail-list-item>
              <detail-list-item term="Emergency Contact1Relationship">Parent-Child</detail-list-item>
              <detail-list-item term="Emergency Contact2Name ">Zhang San</detail-list-item>
              <detail-list-item term="Emergency Contact2Phone">18677876567</detail-list-item>
              <detail-list-item term="Emergency Contact2Relationship ">Parent-Child</detail-list-item>
            </detail-list>
          </a-card>
           <a-card style="margin-top: 24px"  title="Customer Info">
             <div v-for="(fileDetail,index) in dataSource[0].fileDetails" :key="index">
                  <div style="float: left;width:200px;height:200px;margin-right: 10px;margin: 0 8px 8px 0;">
                    <div
                      style="width: 100%;height: 100%;position: relative;padding: 8px;border: 1px solid #d9d9d9;border-radius: 4px;">
                      <p style="text-align: center;font-weight:500;font-size: 16px;">{{dataSource[0].fileName[index]}}</p>
                      <img style="width: 184px;height: 142px;" :src="fileDetail.imgUrl" :preview="dataSource[0].key">
                    </div>
                  </div>
                </div>
          </a-card>
        </a-card>
    </a-spin>
    

  </a-modal>
  
</template>

<script>
import { DetailList } from '@/components'

const DetailListItem = DetailList.Item
export default {
    components: {
      DetailList,
      DetailListItem
    },
      data() {
          return {
            title: 'Customer Detail',
            visible: false,
            confirmLoading: false,
            disableSubmit: false,
            modal: {
              width: '100%',
              style: { top: '20px' },
              fullScreen: true
            },
            dataSource: [
              {
                key: 1,
                fileDetails: [
                  {
                    imgUrl: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=889120611,3801177793&fm=27&gp=0.jpg'
                  },
                  {
                    imgUrl: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2445468140,2491956848&fm=27&gp=0.jpg'
                  },
                  {
                    imgUrl: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=889120611,3801177793&fm=27&gp=0.jpg'
                  },
                  {
                    imgUrl: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2445468140,2491956848&fm=27&gp=0.jpg'
                  }
                ],
                fileName:[
                  'Aadhaar CardFront',
                  'Aadhaar CardBack',
                  'Liveness Detection Photo',
                  'PAN CardPhoto'
                ]
              }
            ]
          };
      },
      computed: {
        bodyStyle () {
            return {
                padding: 0,
                width: '100%',
                height: 577 + 'px',
                overflowY: 'auto',
            }
        }
      },
      methods:{
        handleOk(){
          this.close()  
        },
        handleCancel(){
          this.close()
        },
        edit(){
          this.visible =true
        },
        close () {
          this.$emit('close')
          this.visible = false
        },
         /** Toggle fullscreen display */
      handleClickToggleFullScreen() {
        let mode = !this.modal.fullScreen
        if (mode) {
          this.modal.width = '100%'
          this.modal.style.top = '20px'
        } else {
          this.modal.width = '1200px'
          this.modal.style.top = '50px'
        }
        this.modal.fullScreen = mode
      }
      }
    }
</script>
<style lang='less' scoped>
</style>